import { render, staticRenderFns } from "./TrainingVideo.vue?vue&type=template&id=eba567c8&scoped=true"
import script from "./TrainingVideo.vue?vue&type=script&lang=js"
export * from "./TrainingVideo.vue?vue&type=script&lang=js"
import style0 from "./TrainingVideo.vue?vue&type=style&index=0&id=eba567c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba567c8",
  null
  
)

export default component.exports